import BillingPage from 'components/pages/companies/billing/billing-page'
export default BillingPage
